import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { CommanHeaderComponent } from "../comman-header/comman-header.component";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { ChangePasswordComponent } from "../change-password/change-password.component";
import { LiveBiddingViewComponent } from "../live-bidding-view/live-bidding-view.component";

//Material
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatNativeDateModule } from "@angular/material";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule, MatIconModule } from "@angular/material";
import { MatSortModule } from "@angular/material/sort";
import { MatExpansionModule } from "@angular/material/expansion";
// Pipe for timer formate
import { TimerFormatPipe } from "../../../Shared/Pipe/timer-format.pipe";
import { TimerSendOTPformatPipe } from "../../../Shared/Pipe/timer-SendOTP-format.pipe";

// Moment For date formate
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import * as _moment from "moment";
// Directive
import { OnlyNumbersDirective } from "../../../Shared/directive/only-numbers.directive";
import { NumDeciOnlyDirective } from "../../../Shared/directive/num-deci-only.directive";
import { AlphaOnlyDirective } from "../../../Shared/directive/alpha-only.directive";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { RouterModule } from "@angular/router";

import { RptAuctionComponent } from "src/app/admin/component/rpt-auction/rpt-auction.component";
//import { RptAuctionComponent } from './component/rpt-auction/rpt-auction.component';
import { RptBidderComponent } from "src/app/admin/component/rpt-bidder/rpt-bidder.component";
import { RptAuctionParticipationComponent } from "src/app/admin/component/rpt-auction-participation/rpt-auction-participation.component";
import { RptBidderParticipationComponent } from "src/app/admin/component/rpt-bidder-participation/rpt-bidder-participation.component";
import { RptAuctionWinnerComponent } from "src/app/admin/component/rpt-auction-winner/rpt-auction-winner.component";
import { RptAuctionDepositlistComponent } from "src/app/admin/component/rpt-auction-depositlist/rpt-auction-depositlist.component";
import { RptAuctionRefundlistComponent } from "src/app/admin/component/rpt-auction-refundlist/rpt-auction-refundlist.component";

import { RptBiddingComponent } from "src/app/admin/component/rpt-bidding/rpt-bidding.component";
import { RptBiddingLiveComponent } from "src/app/admin/component/rpt-bidding-live/rpt-bidding-live.component";
import { RptAuctionWinnerBidderParticipationComponent } from "src/app/admin/component/rpt-auction-winner-bidder-participation/rpt-auction-winner-bidder-participation.component";

import { RptAuctionSummaryComponent } from "src/app/admin/component/rpt-auction-summary/rpt-auction-summary.component";
import { RptPaymentDetailComponent } from "src/app/admin/component/rpt-payment-detail/rpt-payment-detail.component";
import { RptPaymentDetailAuctionWiseComponent } from "src/app/admin/component/rpt-payment-detail-auction-wise/rpt-payment-detail-auction-wise.component";
import { RptPaymentDetailAuctionWiseSummaryComponent } from "src/app/admin/component/rpt-payment-detail-auction-wise-summary/rpt-payment-detail-auction-wise-summary.component";

import { PublishedAuctionListComponent } from "src/app/da/component/published-auction-list/published-auction-list.component";
import { AuctionEntryComponent } from "src/app/admin/component/auction-entry/auction-entry.component";
import { AuctionUpdationComponent } from "src/app/admin/component/auction-updation/auction-updation.component";

export const My_Formate = {
  parse: {
    dateInput: [],
  },
  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};
@NgModule({
  declarations: [
    CommanHeaderComponent,
    ChangePasswordComponent,
    OnlyNumbersDirective,
    NumDeciOnlyDirective,
    AlphaOnlyDirective,
    TimerFormatPipe,
    TimerSendOTPformatPipe,
    LiveBiddingViewComponent,

    //added by dilshad
    RptAuctionComponent,
    RptBidderComponent,
    RptBidderParticipationComponent,
    RptBiddingComponent,
    RptAuctionWinnerComponent,
    RptAuctionDepositlistComponent,
    RptAuctionRefundlistComponent,
    RptAuctionParticipationComponent,
    RptBiddingLiveComponent,
    RptAuctionWinnerBidderParticipationComponent,
    RptAuctionSummaryComponent,
    RptPaymentDetailComponent,
    RptPaymentDetailAuctionWiseComponent,
    RptPaymentDetailAuctionWiseSummaryComponent,

    PublishedAuctionListComponent,
    AuctionEntryComponent,
    AuctionUpdationComponent,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    RouterModule,
    MatInputModule,
    MatSelectModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatButtonModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatTableModule,
    MatPaginatorModule,
    MatIconModule,
    MatSortModule,
    MatExpansionModule,
    FormsModule,
    ReactiveFormsModule,
    //ADDED BY DILSHAD
    MatAutocompleteModule,
  ],
  exports: [
    CommanHeaderComponent,
    OnlyNumbersDirective,
    NumDeciOnlyDirective,
    AlphaOnlyDirective,
    MatInputModule,
    MatSelectModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatButtonModule,
    MatTooltipModule,
    MatCheckboxModule,
    TimerFormatPipe,
    TimerSendOTPformatPipe,
    MatTableModule,
    MatPaginatorModule,
    MatIconModule,
    MatSortModule,
    MatExpansionModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,

    //added by dilshad
    RptAuctionComponent,
    RptBidderComponent,
    RptBidderParticipationComponent,
    RptBiddingComponent,
    RptAuctionWinnerComponent,
    RptAuctionParticipationComponent,
    RptBiddingLiveComponent,
    RptAuctionWinnerBidderParticipationComponent,
    RptAuctionSummaryComponent,
    RptPaymentDetailComponent,
    RptPaymentDetailAuctionWiseComponent,
    RptPaymentDetailAuctionWiseSummaryComponent,

    //for commam admin da
    PublishedAuctionListComponent,
    AuctionEntryComponent,
    AuctionUpdationComponent,
  ],
  providers: [
    MatDatepickerModule,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: My_Formate },
  ],
})
export class CommanModule {}
